<template>
	<div>
		<v-layout class="column carousel-slider-container">
			<keep-alive>
			<SubsectionViewer v-if="makeTurizemDetailsActive" />
			</keep-alive>
			<router-view :key="router_view" v-if="!makeTurizemDetailsActive"></router-view>
		</v-layout>
		<!-- <TurisemDialog :key="dialog_key" :showdialog="showSearchDialog" :list_turistic_point="list_turistic_point" /> -->
	</div>
</template>

<script>
import poi from '@/config/api/api_events/poi.js';

import SubsectionViewer from '@/components/carousel/SubsectionViewer';
import map_helper from '@/config/js_helper/map_helper';

export default {
	name: 'Turizëm',
	components: {
		SubsectionViewer,
	},
	computed: {
		showSearchDialog() {
			return this.$route.name == 'turisem_search';
		},
		makeTurizemDetailsActive(){
			return !(this.$route.name == 'TurisemDetail')
		}
	},
	watch: {
		showSearchDialog(show){
			if (!show) {
				this.$store.state.active_loader = false;
			}
		}
	},
	mounted() {
		//this.forceRerender();
		//this.getPoiDataTurisem();
	},
	methods: {
		showSearchBar() {
			if (this.$route.name === 'label_turism' || this.$route.name === 'turisem_map') {
				return true;
			} else {
				return false;
			}
		},
		getPoiDataTurisem() {
			poi.getPoi(this.$store.state.type_language)
				.then((response) => {
					this.map_data = response;
					this.list_turistic_point = response.geodata.features.map((el) => {
						return {
							id: el.properties.poi_id,
							image: el.properties.poi_simg_src,
							title: el.properties.poi_title,
							description: el.properties.poi_desc,
						};
					});
				})
				.catch((err) => {});
		},
		forceRerender() {
			this.router_view = this.router_view + 2;
			this.footer_button = this.footer_button + 2;
			this.$nextTick(() => {
				this.$forceUpdate();
			});
		},
	},
	data() {
		return {
			from_where: 8,
			map_data: [],
			dialog_toogle: false,
			dialog_key: 222,
			list_turistic_point: [],
			map_render: 7000,
			footer_button: 8000,
			router_view: 9000,
			icon_url: [],
		};
	},
};
</script>

<style scoped lang="scss" src="./Turisem.scss"></style>
